import { useNavigation } from '@react-navigation/native';
import { AppNavigationProp } from '../navigation/types';

/**
 * Custom hook for role-based profile navigation.
 * Directs users to either the creator profile or the user profile based on the user's role.
 */
export function useProfileNavigation() {
  const navigation = useNavigation<AppNavigationProp>();

  const navigateToProfile = (userId: string, role?: string) => {
    if (role === 'creator') {
      // @ts-ignore - navigation types can be complex with nested stacks
      navigation.navigate('creatorProfile', { creatorId: userId });
    } else {
      // @ts-ignore
      navigation.navigate('userProfile', { userId });
    }
  };

  return { navigateToProfile };
}
